import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useDataTranslation } from './dataTranslation';
import apiWithLanguage from './apiWithLanguage';

/**
 * Higher-order component that provides data translation capabilities
 * @param {React.Component} WrappedComponent - Component to wrap
 * @returns {React.Component} Enhanced component with translation props
 */
const withDataTranslation = (WrappedComponent) => {
  const WithDataTranslationComponent = (props) => {
    const { currentLanguage, getPathWithLanguage } = useLanguage();
    const dataTranslation = useDataTranslation();

    // Set language for API calls
    React.useEffect(() => {
      apiWithLanguage.setLanguage(currentLanguage);
    }, [currentLanguage]);

    return (
      <WrappedComponent
        {...props}
        currentLanguage={currentLanguage}
        getPathWithLanguage={getPathWithLanguage}
        dataTranslation={dataTranslation}
        apiWithLanguage={apiWithLanguage}
      />
    );
  };

  WithDataTranslationComponent.displayName = `withDataTranslation(${WrappedComponent.displayName || WrappedComponent.name})`;

  return WithDataTranslationComponent;
};

export default withDataTranslation;
